import ApportionmentType from './ApportionmentType.js';
import Attribution from './Attribution.js';
import CharacteristicType from './CharacteristicType.js';
import Citation from './Citation.js';
import Column from './Column.js';
import ColumnDynamicAttribution from './ColumnDynamicAttribution.js';
import Description from './Description.js';
import Dimension from './Dimension.js';
import DimensionDynamicAttribution from './DimensionDynamicAttribution.js';
import FeatureClass from './FeatureClass.js';
import FeatureClassDetail from './FeatureClassDetail.js';
import StatisticalType from './StatisticalType.js';
import TimeContextType from './TimeContextType.js';
import TimeElement from './TimeElement.js';
import TimeGroup from './TimeGroup.js';
function configure({ domain, protocol }) {
    const prefix = `${protocol}://${domain}`;
    Attribution.$AR.url = `${prefix}/api/system-metadata/v1/attributions`;
    CharacteristicType.$AR.url = `${prefix}/api/system-metadata/v1/characteristic-types`;
    Citation.$AR.url = `${prefix}/api/system-metadata/v1/citations`;
    Column.$AR.url = `${prefix}/api/system-metadata/v1/columns`;
    ColumnDynamicAttribution.$AR.url = `${prefix}/api/system-metadata/v1/column-dynamic-attributions`;
    Description.$AR.url = `${prefix}/api/system-metadata/v1/descriptions`;
    Dimension.$AR.url = `${prefix}/api/system-metadata/v1/dimensions`;
    DimensionDynamicAttribution.$AR.url = `${prefix}/api/system-metadata/v1/dimension-dynamic-attributions`;
    FeatureClass.$AR.url = `${prefix}/api/system-metadata/v1/feature-classes`;
    FeatureClassDetail.$AR.url = `${prefix}/api/system-metadata/v1/feature-class-details`;
    TimeElement.$AR.url = `${prefix}/api/system-metadata/v1/time-elements`;
    TimeGroup.$AR.url = `${prefix}/api/system-metadata/v1/time-groups`;
}
const systemMetadata = {
    configure,
    ApportionmentType,
    Attribution,
    CharacteristicType,
    Citation,
    Column,
    ColumnDynamicAttribution,
    Description,
    Dimension,
    DimensionDynamicAttribution,
    FeatureClass,
    FeatureClassDetail,
    StatisticalType,
    TimeContextType,
    TimeElement,
    TimeGroup,
};
/**
 * @namespace system-metadata
 */
export { configure, ApportionmentType, Attribution, CharacteristicType, Citation, Column, ColumnDynamicAttribution, Description, Dimension, DimensionDynamicAttribution, FeatureClass, FeatureClassDetail, StatisticalType, TimeContextType, TimeElement, TimeGroup, };
export default systemMetadata;
